export default __webpack_public_path__ + "static/customdev2-f51f52aa04b98312917709d655ed16f9.jpg";